<app-page-headline
        [breadcrumbTitle]="'AGB'"
        [breadcrumbs]="[
                    { label: 'Startseite', link: '/' },
                    { label: 'AGB', iconClass: 'fa fa-angle-double-right', link: '/agb' }
                  ]"
        [mainTitle]="'Allgemeine Geschäftsbedingungen (AGB)'"
        [subtitle]="'Hier finden Sie alle Informationen zu unseren Geschäftsbedingungen.'"
        [titleImagePath]="'assets/images/saas1/title-logo.png'"
        [backgroundImage]="'assets/images/saas1/work-bg.png'">
</app-page-headline>
<div class="container my-5">
    <div class="card shadow p-4">
        <h4 class="mb-3">Allgemeine Geschäftsbedingungen (AGB)</h4>

        <h5 class="mt-4">1. Geltungsbereich</h5>
        <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen
            <strong>Martin Obrecht, 76137 Karlsruhe, martin.obrecht(at)palladio.de</strong>
            (im Folgenden: „Anbieter“) und den Nutzerinnen und Nutzern dieser Webseite (im Folgenden: „Kunden“) über die auf der Webseite angebotenen Leistungen und Produkte abgeschlossen werden.
        </p>

        <h5 class="mt-4">2. Vertragsgegenstand</h5>
        <p>
            Der Anbieter verkauft digitale Produkte und Dienstleistungen, insbesondere Listen mit Firmen-E-Mail-Adressen, Standortdaten und weiteren Informationen über Unternehmen verschiedener Branchen in Deutschland.
            Kunden können mit einem Listen-Konfigurator individuell eine Liste nach eigenen Kriterien zusammenstellen, einschließlich spezieller Merkmale wie Unternehmensschlüsselwörter und Social-Media-Links.
            Die Einzelheiten der jeweiligen Angebote ergeben sich aus der Produktbeschreibung auf der Website.
        </p>

        <h5 class="mt-4">3. Vertragsschluss</h5>
        <p>
            Mit der Bestellung eines Produkts oder einer Dienstleistung gibt der Kunde ein verbindliches Angebot zum Abschluss eines Vertrags ab.
            Der Vertrag kommt zustande, sobald der Anbieter die Bestellung durch eine Auftragsbestätigung per E-Mail oder durch Bereitstellung des Produkts annimmt.
        </p>

        <h5 class="mt-4">4. Preise und Zahlungsbedingungen</h5>
        <p>
            Alle Preise sind Endpreise und enthalten die gesetzliche Umsatzsteuer, soweit nicht anders angegeben.<br>
            Die Zahlung erfolgt per PayPal oder Banküberweisung.<br>
            Die Lieferung erfolgt nach Zahlungseingang.
        </p>

        <h5 class="mt-4">5. Lieferung und Bereitstellung</h5>
        <p>
            Die Lieferung der digitalen Inhalte erfolgt als Download im Profilbereich der Website.<br>
            Die Bereitstellung erfolgt spätestens innerhalb von 24 Stunden nach Zahlungseingang.
        </p>

        <h5 class="mt-4">6. Widerrufsrecht</h5>
        <p>
            Verbrauchern steht ein gesetzliches Widerrufsrecht zu. Da es sich um digitale Inhalte handelt, die nicht auf einem körperlichen Datenträger geliefert werden, erlischt das Widerrufsrecht gemäß § 356 Abs. 5 BGB, sobald der Anbieter mit der Ausführung des Vertrags begonnen hat, nachdem der Kunde ausdrücklich zugestimmt hat, dass der Anbieter mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnt, und der Kunde seine Kenntnis davon bestätigt hat, dass er durch seine Zustimmung mit Beginn der Ausführung des Vertrags sein Widerrufsrecht verliert.<br>
            Die Kunden werden im Rahmen des Bestellprozesses auf ihr Widerrufsrecht hingewiesen.
        </p>

        <h5 class="mt-4">7. Gewährleistung und Haftung</h5>
        <p>
            Es gelten die gesetzlichen Gewährleistungsrechte.<br>
            Der Anbieter haftet nur für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen.
            Für einfache Fahrlässigkeit haftet der Anbieter nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten).
        </p>

        <h5 class="mt-4">8. Nutzungsrechte</h5>
        <p>
            Mit vollständiger Zahlung erhält der Kunde das nicht ausschließliche, übertragbare Recht zur Nutzung und zum Weiterverkauf der erworbenen digitalen Inhalte.
            Eine Bearbeitung oder Veränderung der Daten ist zulässig.<br>
            Der Anbieter übernimmt keine Verantwortung für die rechtliche Zulässigkeit der Weiterverwendung durch den Kunden; der Kunde ist verpflichtet, die jeweiligen gesetzlichen Regelungen (insbesondere Datenschutz und Wettbewerbsrecht) einzuhalten.
        </p>

        <h5 class="mt-4">9. Datenschutz</h5>
        <p>
            Es gelten die Datenschutzbestimmungen des Anbieters, einsehbar unter <a href="/datenschutz">Datenschutzerklärung</a>.
        </p>

        <h5 class="mt-4">10. Schlussbestimmungen</h5>
        <p>
            Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.<br>
            Es gilt das Recht der Bundesrepublik Deutschland.<br>
            Gerichtsstand ist, soweit gesetzlich zulässig, der Sitz des Anbieters.
        </p>

    </div>
</div>
